import React from 'react';
import css from './footer.module.css';

const Footer = () => <div className={css.container}></div>;

export default Footer;
